import { Flex } from "@jsq/ds/core";
import { useFeatureFlag } from "@jsq/flags-react";
import Titlebar, { TitlebarAction } from "~/pages/UserAndRoles/components/Titlebar";
import { useAgGridUtils } from "~/pages/UserAndRoles/utils/gridUtils";
import { DashboardEmptyState } from "../EmptyState";
import { type ArenaAccessRow, WorkspaceTable } from "../WorkspaceTable";
import { emptyState, pageSpace } from "./style_vanilla.css";

export const WorkspaceDashboard = ({ rowData }: { rowData: ArenaAccessRow[] }) => {
  const { onGridReady, resetFilters, isFilterPresent, onFilterChanged } = useAgGridUtils();
  const isBulkArenaAccessEnabled = useFeatureFlag("faBulkArenaAccess", false);

  const actionButtons: TitlebarAction[] = [
    {
      show: rowData.length > 0 && isFilterPresent,
      buttonProps: {
        variant: "neutral",
        icon: "times",
        key: "clear_filters",
        onClick: resetFilters,
        children: "Clear filters",
      },
    },
  ];

  return (
    <Flex className={pageSpace} flexDirection="column" flex={1}>
      <Titlebar
        title="Your workspaces"
        variant="h2"
        marginBottom="lg"
        actionButtons={actionButtons}
      />

      {rowData.length > 0 ? (
        <WorkspaceTable
          onGridReady={onGridReady}
          arenaAccessRows={rowData}
          domLayout="normal"
          onFilterChanged={onFilterChanged}
          paginationPageSize={50}
          showAccessVia={isBulkArenaAccessEnabled}
        />
      ) : (
        <DashboardEmptyState className={emptyState} />
      )}
    </Flex>
  );
};
